import { RelocationForm } from "@/app/Relocations/Forms/RelocationForm";
import { RecordScreenFormCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenFormCard";
import { RelocationFormValues } from "@/app/Relocations/Utils/getDefaultRelocationValues";
import { RelocationStats } from "@/app/Relocations/Components/RelocationStats";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateRelocationMutation } from "@/app/Relocations/GraphQL/relocationMutations";
import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";
import { getRelocationUpdateInput } from "@/app/Relocations/Utils/getRelocationUpdateInput";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { relocationDetailsValidation } from "@/app/Relocations/Validation/relocationValidation";
import { RelocationWorkOrdersCard } from "@/app/Relocations/Components/RelocationWorkOrdersCard";
import { RelocationAcknowledgementsCard } from "@/app/Relocations/Forms/RelocationAcknowledgementsForm";
import { ConfigurationFormCard } from "@/app/Relocations/Forms/ConfigurationFormCard";
import { OpenDatesFormCard } from "@/app/Relocations/Forms/OpenDatesFormCard";
import { PricingFormCard } from "@/app/Relocations/Forms/PricingFormCard";
import { FeesFormCard } from "@/app/Relocations/Forms/FeesFormCard";
import { RelocationPurchasableExtrasCard } from "@/app/Relocations/Components/RelocationPurchasableExtrasCard";
import { useOfferTripDefaultsUpdate } from "@/app/Relocations/Hooks/useOfferTripDefaultsUpdate";

export function RelocationDetailsScreen() {
  const { mutateAsync } = useGqlMutation(updateRelocationMutation);
  const offerTripDefaultsUpdate = useOfferTripDefaultsUpdate();
  const record = useRelocationRecord();

  return (
    <div className="space-y-12 py-6">
      <RelocationStats />
      {record.workOrders.length > 0 ? <RelocationWorkOrdersCard /> : null}
      <RecordScreenFormCard<RelocationFormValues>
        onSubmit={async (values) => {
          await mutateAsync({
            id: record.id,
            input: values,
          });

          // Awaits only the trip lookup, then shows the dialog without waiting
          // for it to close — so the card returns to its view state behind it.
          await offerTripDefaultsUpdate({
            officeAId:
              values.departureOffice?.connect ?? record.departureOffice.id,
            officeBId:
              values.deliveryOfficeIds?.[0] ?? record.deliveryOffice.id,
            values,
          });
        }}
        validationSchema={toFormikValidationSchema(relocationDetailsValidation)}
        enableReinitialize={true}
        title="Details"
        initialValues={getRelocationUpdateInput(record)}
      >
        <RelocationForm relocation={record} />
      </RecordScreenFormCard>
      <ConfigurationFormCard />
      <PricingFormCard />
      <FeesFormCard />
      <RelocationPurchasableExtrasCard />
      <RelocationAcknowledgementsCard relocation={record} />
      <OpenDatesFormCard />
    </div>
  );
}
